import React, { Component } from 'react';
import { Field, reduxForm, change, initialize, reset } from 'redux-form';
import submit from './submit';
import validate from './validate';
import { connect } from 'react-redux';
import cx from 'classnames';
import {
  Button,
  FormGroup,
  Col,
  FormControl,
  Panel,
  Grid,
  Row
} from 'react-bootstrap';
import withStyles from 'isomorphic-style-loader/withStyles';
import { object } from 'twilio/lib/base/serialize';

// Translation
import { FormattedMessage, injectIntl } from 'react-intl';
import messages from '../../../../locale/messages';
import InputFieldComponent from '../../../Common/FormField/InputFieldComponent';

import s from './WhyHostFormBlock7.css';
import bt from '../../../../components/commonStyle.css';

class WhyHostFormBlock7 extends Component {

  static defaultProps = {

  };

  constructor(props) {
    super(props);

    this.state = {
      addMore: ['1'],
      addMoreCount: 1
    };
    this.handleAddMore = this.handleAddMore.bind(this)
    this.handleRemove = this.handleRemove.bind(this)
  }

  componentDidMount() {
    const { initialValues } = this.props
    const { addMore, addMoreCount } = this.state

    let list = []
    let num = 0
    const values = Object.keys(initialValues).map((item) => {
      if (item.startsWith('faqTitle') && initialValues[item] != '') {
        num = num + 1
        return list.push(`${num}`)
      }
    })
    if (list.length < 1) {
      this.setState({
        addMore: ["1"],
        addMoreCount: 1
      })
    } else {
      this.setState({
        addMore: list,
        addMoreCount: num
      })
    }

  }

  handleAddMore() {
    const { addMore, addMoreCount } = this.state

    let count = addMoreCount + 1
    let addMoreUpdate = addMore.concat(`${count}`)
    if (count < 9) {
      this.setState({
        addMore: addMoreUpdate,
        addMoreCount: count
      })
    }
  }

  async handleRemove() {
    const { addMore, addMoreCount } = this.state
    const { change } = this.props

    let addMoreUpdate = addMore.filter((item) => item != addMoreCount)
    let count = addMoreCount - 1
    if (count >= 1) {
      this.setState({
        addMore: addMoreUpdate,
        addMoreCount: count
      })

      await change(`faqTitle${addMoreCount}`, '')
      await change(`faqContent${addMoreCount}`, '')
    }
  }

  render() {

    const { error, handleSubmit, submitting, dispatch, initialValues } = this.props;
    const { formatMessage } = this.props.intl;
    const { addMore } = this.state

    return (
      <Grid fluid>
        <Row>
          <Col lg={12} md={12} sm={12} xs={12}>
            <h1 className={s.siteAdminHeading}><FormattedMessage {...messages.whyBecomeHostBlock7Tab} /></h1>
          </Col>
          <Col xs={12} sm={12} md={12} lg={8} className={s.blockCenter}>
            <Panel className={cx(s.panelHeader)}>
              <form onSubmit={handleSubmit(submit)}>
                {error && <strong>{formatMessage(error)}</strong>}

                {
                  addMore.includes('1') && <>
                    <Field
                      name="faqTitle1"
                      type="text"
                      component={InputFieldComponent}
                      label={formatMessage(messages.faqBlockTitle)}
                      placeholder={formatMessage(messages.faqBlockTitlePlaceHolder)}
                      inputClass={bt.commonControlInput}
                      formGroupClass={bt.space4}
                      labelNumber={'1'}
                    />
                    <Field
                      name="faqContent1"
                      component={InputFieldComponent}
                      componentClass={'textarea'}
                      inputClass={bt.commonControlTextArea}
                      formGroupClass={bt.space4}
                      label={formatMessage(messages.faqBlockContent)}
                      labelNumber={'1'}
                      placeholder={formatMessage(messages.faqBlockContentPlaceHolder)}
                    />
                  </>
                }

                {
                  addMore.includes('2') && <>
                    <Field
                      name="faqTitle2"
                      type="text"
                      component={InputFieldComponent}
                      formGroupClass={bt.space4}
                      label={formatMessage(messages.faqBlockTitle)}
                      placeholder={formatMessage(messages.faqBlockTitlePlaceHolder)}
                      inputClass={bt.commonControlInput}
                      labelNumber={'2'}
                    />
                    <Field
                      name="faqContent2"
                      component={InputFieldComponent}
                      formGroupClass={bt.space4}
                      label={formatMessage(messages.faqBlockContent)}
                      componentClass={'textarea'}
                      inputClass={bt.commonControlTextArea}
                      labelNumber={'2'}
                      placeholder={formatMessage(messages.faqBlockContentPlaceHolder)}
                    />
                  </>
                }
                {
                  addMore.includes('3') && <>
                    <Field
                      name="faqTitle3"
                      type="text"
                      component={InputFieldComponent}
                      formGroupClass={bt.space4}
                      label={formatMessage(messages.faqBlockTitle)}
                      placeholder={formatMessage(messages.faqBlockTitlePlaceHolder)}
                      inputClass={bt.commonControlInput}
                      labelNumber={'3'}
                    />
                    <Field
                      name="faqContent3"
                      component={InputFieldComponent}
                      formGroupClass={bt.space4}
                      label={formatMessage(messages.faqBlockContent)}
                      componentClass={'textarea'}
                      inputClass={bt.commonControlTextArea}
                      labelNumber={'3'}
                      placeholder={formatMessage(messages.faqBlockContentPlaceHolder)}
                    />
                  </>
                }
                {
                  addMore.includes('4') && <>
                    <Field
                      name="faqTitle4"
                      type="text"
                      component={InputFieldComponent}
                      formGroupClass={bt.space4}
                      label={formatMessage(messages.faqBlockTitle)}
                      placeholder={formatMessage(messages.faqBlockTitlePlaceHolder)}
                      labelNumber={'4'}
                      inputClass={bt.commonControlInput}
                    />
                    <Field
                      name="faqContent4"
                      component={InputFieldComponent}
                      formGroupClass={bt.space4}
                      label={formatMessage(messages.faqBlockContent)}
                      labelNumber={'4'}
                      componentClass={'textarea'}
                      inputClass={bt.commonControlTextArea}
                      placeholder={formatMessage(messages.faqBlockContentPlaceHolder)}
                    />
                  </>
                }
                {
                  addMore.includes('5') && <>
                    <Field
                      name="faqTitle5"
                      type="text"
                      component={InputFieldComponent}
                      formGroupClass={bt.space4}
                      label={formatMessage(messages.faqBlockTitle)}
                      placeholder={formatMessage(messages.faqBlockTitlePlaceHolder)}
                      labelNumber={'5'}
                      inputClass={bt.commonControlInput}
                    />
                    <Field
                      name="faqContent5"
                      component={InputFieldComponent}
                      formGroupClass={bt.space4}
                      label={formatMessage(messages.faqBlockContent)}
                      labelNumber={'5'}
                      componentClass={'textarea'}
                      inputClass={bt.commonControlTextArea}
                      placeholder={formatMessage(messages.faqBlockContentPlaceHolder)}
                    />
                  </>
                }
                {
                  addMore.includes('6') && <>
                    <Field
                      name="faqTitle6"
                      type="text"
                      component={InputFieldComponent}
                      formGroupClass={bt.space4}
                      label={formatMessage(messages.faqBlockTitle)}
                      placeholder={formatMessage(messages.faqBlockTitlePlaceHolder)}
                      labelNumber={'6'}
                      inputClass={bt.commonControlInput}
                    />
                    <Field
                      name="faqContent6"
                      component={InputFieldComponent}
                      formGroupClass={bt.space4}
                      componentClass={'textarea'}
                      inputClass={bt.commonControlTextArea}
                      label={formatMessage(messages.faqBlockContent)}
                      labelNumber={'6'}
                      placeholder={formatMessage(messages.faqBlockContentPlaceHolder)}
                    />
                  </>
                }
                {
                  addMore.includes('7') && <>
                    <Field
                      name="faqTitle7"
                      type="text"
                      component={InputFieldComponent}
                      formGroupClass={bt.space4}
                      label={formatMessage(messages.faqBlockTitle)}
                      placeholder={formatMessage(messages.faqBlockTitlePlaceHolder)}
                      labelNumber={'7'}
                      inputClass={bt.commonControlInput}
                    />
                    <Field
                      name="faqContent7"
                      component={InputFieldComponent}
                      formGroupClass={bt.space4}
                      label={formatMessage(messages.faqBlockContent)}
                      componentClass={'textarea'}
                      inputClass={bt.commonControlTextArea}
                      labelNumber={'7'}
                      placeholder={formatMessage(messages.faqBlockContentPlaceHolder)}
                    />
                  </>
                }
                {
                  addMore.includes('8') && <>
                    <Field
                      name="faqTitle8"
                      type="text"
                      component={InputFieldComponent}
                      formGroupClass={bt.space4}
                      label={formatMessage(messages.faqBlockTitle)}
                      placeholder={formatMessage(messages.faqBlockTitlePlaceHolder)}
                      inputClass={bt.commonControlInput}
                      labelNumber={'8'}
                    />
                    <Field
                      name="faqContent8"
                      component={InputFieldComponent}
                      formGroupClass={bt.space4}
                      label={formatMessage(messages.faqBlockContent)}
                      labelNumber={'8'}
                      componentClass={'textarea'}
                      inputClass={bt.commonControlTextArea}
                      placeholder={formatMessage(messages.faqBlockContentPlaceHolder)}
                    />
                  </>
                }
                <div className={s.displayFlex}>
                  {addMore?.length < 8 && <Button className={cx(bt.btnPrimary, bt.btnLarge, s.btnWidth)} type="button" disabled={submitting} onClick={() => this.handleAddMore()}>
                    <FormattedMessage {...messages.addLabel} />
                  </Button>}
                  <Button className={cx(bt.btnPrimary, bt.btnLarge, s.btnWidth)} type="submit" disabled={submitting}>
                    <FormattedMessage {...messages.save} />
                  </Button>
                  <Button className={cx(bt.btnPrimaryBorder, bt.btnLarge, s.btnWidth)} type="button" disabled={submitting} onClick={() => this.handleRemove()}>
                    <FormattedMessage {...messages.remove} />
                  </Button>
                </div>
              </form>
            </Panel>
          </Col>
        </Row>
      </Grid>
    );
  }
}
WhyHostFormBlock7 = reduxForm({
  form: 'WhyHostForm',
  validate
})(WhyHostFormBlock7);

let mapState = (state) => ({})

let mapDispatch = {
  change,
  // reset
}

export default injectIntl(withStyles(s, bt)(connect(mapState, mapDispatch)(WhyHostFormBlock7)))